import "./styles.scss";

import { OverlayProps } from "./types";

const Overlay = ({ style, children }: OverlayProps) => (
  <div className="overlay" style={style}>
    {children}
  </div>
);

export default Overlay;
